angular.module('rjmNg.services').factory 'appRoute', [
  "$routeParams"
  ($routeParams) ->
    (route, clientId = $routeParams.clientId) ->
      return "client/#{clientId}/dashapp#{route}"
]
